module.exports = __webpack_public_path__ + "fonts/microsoft_logo.0fb2d378fe231c362aa2b605376b525c.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/login/microsoft_logo.png
// module id = 106
// module chunks = 9